<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    {{ $t('UploadImage') }}
    <v-file-input
      v-model="files"
      multiple
    />
    <div
      class="pa-4"
      v-html="log"
    />
    <v-btn
      block
      color="amber lighten-4 black--text"
      elevation="0"
      @click="upload"
    >
      {{ $t('UploadNow') }}
    </v-btn>
  </div>
</template>

<script>
import { keyBy } from 'lodash-es'
import IKUtils from 'innerken-js-utils'
import Dish from '@/model/dataLayer/api/dish/Dish'

export default {
  name: 'UploadImage',
  data: function () {
    return {
      files: [],
      dishList: [],
      log: ''
    }
  },
  watch: {
    files (val) {
      this.updateInfo(val)
    }
  },
  async mounted () {
    this.dishList = await Dish.getList(true)
  },
  methods: {
    async updateInfo (files) {
      console.log(files)
    },
    async upload () {
      this.log = ''
      const fileDict = keyBy(this.files, (f) => f.name.split('.')[0])
      const needUploadDishes = Object.keys(fileDict)
      const dishDict = keyBy(this.dishList, 'code')
      console.log(dishDict)
      console.log(needUploadDishes)
      for (const id of needUploadDishes) {
        const newItem = IKUtils.deepCopy(dishDict[id])
        if (newItem) {
          newItem.file = fileDict[id]
          console.log(newItem)
          const res = await Dish.edit(newItem)
          this.log += id + ':' + res.status + '<br>'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
